import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';

const ProductInventory = ({
  data,
  handleValue = null,
  leadId,
  getMaterial,
  getMateriaById,
  handleDataFilter = null,
  handleremoveValue = null,
  prefilledData = null,
  commData
}) => {
  const objInput = { category_id: '', material_id: '', quantity: '' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputListData3, setInputListData3] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [editInput, setEditInput] = useState([]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [catId, setCatId] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);
  const [gateData, setGateData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditData, setIsEditData] = useState(false);

  function editProduct(){
    
  }
  
  useEffect(() => {
    if (
      prefilledData?.material_hardware !== undefined &&
      prefilledData?.material_hardware !== null
    ) {
      const {
        material,
        prod_array
      } = prefilledData?.material_hardware;
      console.log(prod_array);
      if (prod_array != '') {
        // let init = 0;
        let prod_length=prod_array.length;
        // const list = [...inputValue];
          // console.log(prod_array);
          // console.log('setting values');
          setInputValue(prod_array);
          setEditInput(prod_array);
          setInputListData1(prod_array[prod_length-1]['category_name']);
          setInputListData2(prod_array[prod_length-1]['quantity']);
          setInputListData3(prod_array[prod_length-1]['material_name']);
          
          if (prod_length > 1) {
            setIsEditData(true);
            setInputList([...inputList, { id: prod_length-1 }]);
          }
        // console.log('out');
        // console.log(inputValue);
      }
    }
  }, [prefilledData]);

  const handleData = () => {
    if (data) {
      setGateData(data);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      handleData();
    }
  }, [data]);

  const addGates = () => {
    if (
      !inputListData1 ||
      !inputListData2 ||
      !inputListData3 ||
      isError
      // !inputListData1.length ||
      // !inputListData2.length ||
      // !inputListData3.length
    ) {
      console.log(inputListData1+' 2 '+inputListData2+' 3 '+inputListData3+' 4 '+isError);
      setIsError(true);
      return false;
    }
    setInputValue([
      ...inputValue,
      { category_id: '', material_id: '', quantity: '' },
    ]);

    // if (inputListData1?.id) {
    if (inputListData1) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }

    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
    setInputListData3('');
  };
  const removeGate = (index = null) => {
    setInputListData1(inputValue[index]?.category_id);
    setInputListData2(inputValue[index]?.quantity);
    setInputListData3(inputValue[index]?.material_id);
    let removeArray = inputValue.splice(index + 1, 1);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  const handleInitalValue = () => {
    setCatVal('');
    setNumberVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };

  const handleFormData = () => {
    if (inputValue) {
      handleValue({
        productData: inputValue,
      });
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [inputValue]);

  useEffect(() => {
    if (catId) {
      (async () => {
        setIsLoading(true);
        await getMateriaById(catId);
        setIsLoading(false);
      })();
    }
  }, [catId]);

  useEffect(() => {
    if (getMaterial) {
      setMaterialData(getMaterial);
    }
  }, [getMaterial]);

  const handleInputValue = (val, key, index) => {
    const list = [...inputValue];
    console.log(list);
    console.log(index);
    console.log(key);
    list[index][key] = val;
    setInputValue([...list]);
  };
  
  return (
    <Fragment>
      <FormSection title={localization.productInventory} isLoading={isLoading}>
        {(isEditData)?
            editInput &&
            editInput.map((item, index) => {
              return(
                <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={gateData}
                    getIdValue={(val) => {
                      setInputListData1(val.value);
                      setIsCurrentRef(index + 1);
                      setCatId(val.id);
                      handleInputValue(val.id, 'category_id', index);
                    }}
                    value={item.category_name}
                    // errorMsg={localization.isRequired}
                    // required
                    // isStarRequired={true}
                  />
                  
                  {inputValue[index].category_id && (
                    <DropDownInput
                      label={localization.selectMaterial}
                      data={materialData.length === 0 ? [] : materialData}
                      getIdValue={(val) => {
                        setIsCurrentRef(index + 1);
                        setInputListData3(val.value);
                        handleInputValue(val.id, 'material_id', index);
                      }}
                      errorMsg={localization.isRequired}
                      required
                      isStarRequired={true}
                      value={item.material_name}
                    />
                  )}

                  <ConstantInput
                    label={localization.quantity}
                   
                    type="number"
                    min={0}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'quantity', index);
                      setIsError(
                        !Regex.numericNotZero.test(
                          item?.quantity
                        )
                      );
                    }}
                    value={item.quantity}
                    // required
                    // isStarRequired={true}
                  />
                  <div>
                    <ButtonWithIcon
                      title="Remove"
                      onClick={() => removeGate(index)}
                    />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
         
              );
               })
        :
          <>
          <div className="w-100 row mx-0">
          <div
            ref={inputRef.current[0]}
            className="row mx-0"
            // disabled={catVal && numberVal ? true : false}
          >
            <DropDownInput
              label={localization.selectCategory}
              data={gateData}
              getIdValue={(val) => {
                setCatVal(val.value);
                setCatId(val.id);
                setInputListData1(val.value);
                setIsCurrentRef(0);
                handleInputValue(val.id, 'category_id', 0);
              }}
              // errorMsg={localization.isRequired}
              // value={catVal}
              value={inputValue[0].category_name}
              // required
              // isStarRequired={true}
            />
            {inputValue[0].category_id && (
              <DropDownInput
                label={localization.selectMaterial}
                data={materialData}
                getIdValue={(val) => {
                  setIsCurrentRef(0);
                  setInputListData3(val.value);
                  handleInputValue(val.id, 'material_id', 0);
                }}
                errorMsg={localization.requiredselectMaterial}
                required
                isStarRequired={true}
                value={inputValue[0].material_name}
              />
            )}

            <ConstantInput
              label={localization.quantity}
              /* errorMsg={
                inputValue[0].quantity
                  ? localization.numberError
                  : localization.isRequired
              } */
              // regex={Regex.numericNotZero.test(inputValue[0].quantity)}
              type="number"
              // value={numberVal}
              handleChange={(val) => {
                // setNumberVal(val);
                setInputListData2(val);
                setIsCurrentRef(0);
                handleInputValue(val, 'quantity', 0);
                setIsError(!Regex.numericNotZero.test(inputValue[0]?.quantity));
              }}
              value={inputValue[0].quantity}
              // required
              // isStarRequired={true}
              min={0}
            />

            <div>
              {inputList.length === 0 && catVal && numberVal ? (
                <Fragment>
                  <ButtonWithIcon
                    onClick={handleInitalValue}
                    title={localization.clear}
                  />
                  <br />
                  <br />
                </Fragment>
              ) : null}
            </div>
          </div>
        </div>

        {inputList &&
          inputList.map((item, index) => {
            // {console.log('inside');
            //   console.log(index);}
            return (
              <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={gateData}
                    getIdValue={(val) => {
                      setInputListData1(val.value);
                      setIsCurrentRef(index + 1);
                      setCatId(val.id);
                      handleInputValue(val.id, 'category_id', index + 1);
                    }}
                    value={inputValue[index+1].category_name}
                    // errorMsg={localization.isRequired}
                    // required
                    // isStarRequired={true}
                  />
                  {inputValue[index + 1].category_id && (
                    <DropDownInput
                      label={localization.selectMaterial}
                      data={materialData.length === 0 ? [] : materialData}
                      getIdValue={(val) => {
                        setIsCurrentRef(index + 1);
                        setInputListData3(val.value);
                        handleInputValue(val.id, 'material_id', index + 1);
                      }}
                      errorMsg={localization.isRequired}
                      required
                      isStarRequired={true}
                      value={inputValue[index+1].material_name}
                    />
                  )}

                  <ConstantInput
                    label={localization.quantity}
                    /* errorMsg={
                      inputValue[index + 1].quantity
                        ? localization.numberError
                        : localization.isRequired
                    }
                    regex={Regex.numericNotZero.test(
                      inputValue[index + 1].quantity
                    )} */
                    type="number"
                    min={0}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'quantity', index + 1);
                      setIsError(
                        !Regex.numericNotZero.test(
                          inputValue[index + 1]?.quantity
                        )
                      );
                    }}
                    value={inputValue[index+1].quantity}
                    // required
                    // isStarRequired={true}
                  />
                  <div>
                    <ButtonWithIcon
                      title="Remove"
                      onClick={() => removeGate(index)}
                    />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            );
          })}
          </>
        }
        
        
        <span>
          {isError ? (
            <label className="error d-block">{localization.enterField}</label>
          ) : null}
        </span>
        <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div>
      </FormSection>
    </Fragment>
  );
};

export default ProductInventory;
